import { Component, AfterViewInit, EventEmitter, OnInit, OnChanges, ViewChild, ElementRef, Input, Output } from '@angular/core';

@Component({
    selector: 'hms-edit-inputs',
    templateUrl: './hms-edit-inputs.component.html',
    styleUrls: ['./hms-edit-inputs.component.scss']
})

export class HmsEditInputsComponent implements OnInit {

    @Input() disabled: any;
    @Input() onChange: any;
    @Input() hideSeconds: any;
   
    @Output() durationChange = new EventEmitter();

    private _duration: number;
    get duration(): number { return this._duration };
    @Input() set duration(value: number) {

        this._duration = value;

        this.updateDuration(value);

        if (this.onChange) {
            this.onChange();
        }

        this.durationChange.emit(this.duration);
    }

    public time: any;

    constructor() { }

   

    ngOnInit() {
        this.updateDuration(this.duration);
    }

    public changedTime = function () {
        this.duration = this.time.hours * 60 + (+this.time.minutes) + (this.time.seconds ? (+this.time.seconds / 60) : 0);
    };

    public updateDuration = function (value: number) {

        var sighn = Math.sign(value);

        var allMinuteTime = parseFloat(Math.abs(value).toString());

        var hours = Math.floor(allMinuteTime / 60);

        var minutes = Math.floor(allMinuteTime - hours * 60);

        var seconds = Math.round((allMinuteTime - ((hours * 60) + minutes)) * 60);

        if (minutes === 60) { hours += 1; minutes = 0; }

        if (seconds === 60) { minutes += 1; seconds = 0; }

        this.time = {
            hours: sighn * hours,
            minutes: minutes,
            seconds: seconds
        };
    };
}